/**
 * An empty fallback implementation for browsers without BroadcastChannel
 * support.
 */
export class StubBroadcastChannel implements BroadcastChannel {
  name: string

  /** Stubbed BroadcastChannel method */
  constructor(name: string) {
    this.name = name
  }

  /** Stubbed BroadcastChannel method */
  postMessage(_: unknown) {}

  /** Stubbed BroadcastChannel method */
  addEventListener() {}

  /** Stubbed BroadcastChannel method */
  removeEventListener() {}

  /** Stubbed BroadcastChannel method */
  onmessage() {}

  /** Stubbed BroadcastChannel method */
  onmessageerror() {}

  /** Stubbed BroadcastChannel method */
  dispatchEvent() {
    return true
  }

  /** Stubbed BroadcastChannel method */
  close() {}
}
